import React, { useEffect, useState } from 'react'
import { useZoomEvent } from '../../hook'
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';

const KendoTextFilter = props => {
  const { onChange } = props
  const [txtValue, setTxtValue] = useState('')
  const [historyValue, setHistoryValue] = useState('')
  const [historyField, setHistoryField] = useState('')
  const { onFocus, onBlur } = useZoomEvent()

  useEffect(() => {
    if (historyField !== '' && historyField !== props.field) {
      setTxtValue('')
    }
  }, [historyField, props.field])
  if (props.rowType === 'groupFooter') {
    return <td></td>
  } else if (props.rowType === 'groupHeader') {
    return null
  } else {
    return (
      <div className="k-filtercell">
        <input
          type="text"
          className="k-textbox InputTablaNew"
          onChange={event => {
            var text = event.target.value
            setHistoryValue(txtValue)
            setTxtValue(text)
            setHistoryField(props.field)
          }}
          onFocus={e => {
            setHistoryValue(txtValue)
            onFocus(e)
          }}
          onKeyPress={event => {
            if (event.key === 'Enter') {
              if (historyValue !== txtValue) {
                setHistoryValue(txtValue)
                setHistoryField(props.field)

                if (txtValue !== '') {
                  onChange({
                    value: txtValue,
                    operator: 'contains',
                    syntheticEvent: event,
                  })
                } else {
                  onChange({
                    value: '',
                    operator: '',
                    syntheticEvent: event,
                  })
                }
              }
            }
          }}
          onBlur={e => {
            if (historyValue !== txtValue) {
              if (txtValue !== '') {
                onChange({
                  value: txtValue,
                  operator: 'contains',
                })
              } else {
                onChange({
                  value: '',
                  operator: '',
                })
              }
            }
            onBlur(e)
          }}
          value={txtValue}
          // fullWidth={true}
          maxLength="100"
        />

        <button
          className="k-button k-button-icon k-clear-button-visible"
          title="Clear"
          // disabled={!value}
          onClick={event => {
            onChange({
              value: '',
              operator: '',
              syntheticEvent: event,
            })
            setHistoryValue('')
            setTxtValue('')
            setHistoryField('')
          }}
        >
          {/* <span className="k-icon k-i-filter-clear"  /> */}
          <FilterAltOffIcon fontSize="small" />
        </button>
      </div>
    )
  }
}

export default KendoTextFilter
